import styled from 'styled-components'

export const InputSpacing = styled.div`
  width: 24px;
  height: 24px;
`

export const RadioButtonWrapper = styled.div`
  margin-right: -12px;
`
